import { WebMercatorViewport } from '@math.gl/web-mercator';

type CalculateMapCenterCoordinates = {
  stores: AdaptedStore[] | AdaptedStore<true>[];
  mapWidth: number;
  mapHeight: number;
};

export function calculateMapCenterCoordinates({
  stores,
  mapHeight,
  mapWidth,
}: CalculateMapCenterCoordinates) {
  if (!mapHeight || !mapWidth || mapHeight <= 0 || mapWidth <= 0) return null;

  const latitudes = stores.map(store => store.address.geometry?.lat ?? 0);
  const longitudes = stores.map(store => store.address.geometry?.lon ?? 0);

  if (latitudes.length === 0 || longitudes.length === 0) return null;

  const cornersLngLat: [[number, number], [number, number]] = [
    [Math.min(...longitudes), Math.min(...latitudes)],
    [Math.max(...longitudes), Math.max(...latitudes)],
  ];

  const viewport = new WebMercatorViewport({
    width: mapWidth,
    height: mapHeight,
  }).fitBounds(cornersLngLat, { padding: 50 });

  const { longitude, latitude, zoom } = viewport;

  return { longitude, latitude, zoom };
}
